import { render, staticRenderFns } from "./propertyCommunityList.vue?vue&type=template&id=2eae45c7&scoped=true"
import script from "./propertyCommunityList.vue?vue&type=script&lang=js"
export * from "./propertyCommunityList.vue?vue&type=script&lang=js"
import style0 from "./propertyCommunityList.vue?vue&type=style&index=0&id=2eae45c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae45c7",
  null
  
)

export default component.exports